import { useState } from "react";
import { serverUrl } from "../../services/configs/server";
import { useLocation } from "react-router-dom";

import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { Loader } from "../../components/utilities/loader";
import { useAuth } from "../../services/authentication/authentication.context";


export const PaymentPagent = () => {

    const { access_token, tutorial } = useLocation().state;
    const { token } = useAuth();

    const [credentials, setCredentials] = useState({
        phoneNumber: '',
        amount: 500
    });
    const [loading, setLoading] = useState(false);

   const {phoneNumber, amount} = credentials;

   const isNull = (v) => v === null || v === '' || v === undefined;

    const requestPayment = async () => {

        if (isNull(phoneNumber) || isNull(amount)){
            return alert("Please provide all required information");
        }

        const paymentData = {
            amount: amount,
            phoneNumber: phoneNumber,
            token: access_token,
            itemId: tutorial._id
        }

        const makePayment = () => {
            console.log({token})
            return fetch(`${serverUrl}/tutorial/payment`,{
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(paymentData)
            })
        }

        try {
            setLoading(true);
            const response = await makePayment();
            const status = response.status;
            if (status === 202){
                alert("Payment successful");
            }else if(status === 409){
                 alert("You already subscribed to this tutorial");
            }
            setLoading(false);
        } catch (error) {
            console.log({error});
        }
    }



    return (
        <div className="page-body">
            <BmsHeader />
            <SkewBox title={"Complete payment"} />
            <div className="centered-page">
                {loading && <Loader />}
                 
                <div className="page-caption">
                    <span className="wlc">Complete payment</span>
                </div>
                <div className="form-container">
                    <div className="input-container">
                        <span className="input-cap">Phone number</span>
                        <input 
                            type="email" 
                            value={phoneNumber} 
                            className="input"
                            placeholder="e.g. mymail@provider.com"
                            onChange={(e) => setCredentials((cred) => (
                                {...cred, phoneNumber: e.target.value}
                            )) } 
                        />
                    </div>
                    <div className="input-container">
                        <span className="input-cap">Amount</span>
                        <input 
                            type="text" 
                            value={amount} 
                            className="input"
                            placeholder="e.g. mymail@provider.com"
                            disabled 
                        />
                    </div>
                  
                    <button 
                        className="form-button"
                        onClick={() => {
                            requestPayment();
                        } }
                    >
                        Pay with momo
                    </button>
                   
                   
                </div>
            </div>
        </div>
    )
}